import {RESP} from '../../../../_metronic/helpers/network/network-consts'
import type {GroupBase, OptionsOrGroups} from 'react-select'
import {initialFilterOutlet} from '../../outlet/core/_models'
import {getOutletById, getOutlets} from '../../outlet/core/_requests'

type Additional = {page: number}
export type GymOutletOption = {label: string; value: string}
export const GYM_SUB_BRAND_ID = 'cc58bd4b-3153-43b9-a29c-ff92d723e207'
const GUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

const isClosedOutlet = (outlet: {name?: string; status?: string}) =>
  [outlet.name, outlet.status].some((value) =>
    typeof value === 'string' ? value.toLowerCase().includes('close') : false
  )

export const getGymOutletOptionByGuid = async (
  outletGuid: string
): Promise<GymOutletOption | null> => {
  if (!GUID_PATTERN.test(outletGuid)) return null

  try {
    const response = await getOutletById(outletGuid)
    const outlet = response?.response?.data

    if (
      response?.response?.code !== RESP.SUCCESS ||
      !outlet?.guid ||
      !outlet?.name ||
      outlet.sub_brand_id !== GYM_SUB_BRAND_ID ||
      outlet.status?.toLowerCase() !== 'active' ||
      isClosedOutlet(outlet)
    ) {
      return null
    }

    return {value: outlet.guid, label: outlet.name}
  } catch {
    return null
  }
}

export const loadGymOutletOptions = async (
  query: string,
  _loadedOptions: OptionsOrGroups<GymOutletOption, GroupBase<GymOutletOption>>,
  additional: Additional | undefined
) => {
  const page = additional?.page || 1

  try {
    const response = await getOutlets({
      ...initialFilterOutlet,
      filter: {
        ...initialFilterOutlet.filter,
        set_name: Boolean(query),
        name: query,
        set_sub_brand_id: true,
        sub_brand_id: GYM_SUB_BRAND_ID,
        set_status: true,
        status: 'active',
      },
      page,
      limit: 25,
    })

    if (response?.response?.code !== RESP.SUCCESS) {
      return {options: [], hasMore: false, additional: {page: page + 1}}
    }

    const options = (response.response.data || [])
      .filter((outlet) => !isClosedOutlet(outlet))
      .map((outlet) => ({label: outlet.name || '', value: outlet.guid || ''}))
      .filter((outlet) => outlet.label && outlet.value)

    return {
      options,
      hasMore: page < (response.response.total_page || 1),
      additional: {page: page + 1},
    }
  } catch {
    return {options: [], hasMore: false, additional: {page: page + 1}}
  }
}
